/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { StandardBackupScheduleConfig } from '../models/StandardBackupScheduleConfig';

export class NativeStandardBackupSchedules {
  /**
  * Target region for the native backup.
  */
  'targetRegion': string;
  'scheduleConfig': StandardBackupScheduleConfig;
  /**
  * Backup retention period, in days.
  */
  'backupRetentionDays': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "targetRegion",
      "baseName": "targetRegion",
      "type": "string",
      "format": ""
    },
    {
      "name": "scheduleConfig",
      "baseName": "scheduleConfig",
      "type": "StandardBackupScheduleConfig",
      "format": ""
    },
    {
      "name": "backupRetentionDays",
      "baseName": "backupRetentionDays",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NativeStandardBackupSchedules.attributeTypeMap;
  }

  public constructor() {
  }
}

